export const COOKIEBAR_COOKIE = 'cookiebar/COOKIEBAR_COOKIE';
export const COOKIEBAR_COOKIE_SET = 'cookiebar/COOKIEBAR_COOKIE_SET';
export const COOKIEBAR_COOKIE_CLEARALL = 'cookiebar/COOKIEBAR_COOKIE_CLEARALL';
